export default "__VITE_ASSET__Da557GZ2__"